module.exports = __webpack_public_path__ + "static/weil-c357181a7e07809ad66f345c12627b76.jpg";